<template>
  <div class="timeline-wrapper">
    <div class="timeline">
      <template v-for="(step, index) in stepsList" :key="index">
        <div class="timeline-step">
          <div
            class="status-circle"
            :class="{ active: isStepActive(step.stepIndex) }"
          >
            <q-icon :name="step.icon" size="26px" color="white" />
          </div>
          <div class="label" :class="{ active: isStepActive(step.stepIndex) }">
            {{ step.label }}
          </div>
        </div>
        
        <div
          v-if="index < stepsList.length - 1"
          class="connector"
          :class="{ active: isStepActive(stepsList[index + 1].stepIndex) }"
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
import { StatusOrderStepList } from '@/helpers/constants/StatusOrder'

export default {
  name: 'StatusOrderStep',
  props: { 
    statusPed: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentStepObj() {
      const statusUpper = this.statusPed?.toUpperCase();
      if (!statusUpper || statusUpper === 'CANCELADO') return null;
      return StatusOrderStepList.find(s => s.key === statusUpper) || null;
    },

    currentWeight() {
      return this.currentStepObj ? this.currentStepObj.stepIndex : 0;
    },

    stepsList() {
      const currentStatus = this.statusPed?.toUpperCase();
      const isCurrentDynamic = Boolean(this.currentStepObj?.isDynamic);
      return StatusOrderStepList.filter(step => {
        if (!step.isDynamic) return true;
        if (!isCurrentDynamic) return false;
        if (step.stepIndex < this.currentWeight) {
          return step.isDefault;
        }
        if (step.stepIndex === this.currentWeight) {
          return step.key === currentStatus;
        }
        if (step.stepIndex === this.currentWeight + 1) {
          return step.isPlaceholder;
        }
        return false;
      });
    }
  },
  methods: {
    isStepActive(stepWeight) {      
      return this.currentWeight >= stepWeight;
    }
  }
}
</script>

<style scoped>
.timeline-wrapper {   
  width: 100%;
  overflow-x: auto;     
  padding-bottom: var(--space__0-75x);    
  scrollbar-width: thin; 
  white-space: nowrap;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}
.timeline-wrapper::-webkit-scrollbar {
  height: 8px;  
}
.timeline {
  display: flex;
  align-items: flex-start;
  min-width: max-content;
  padding: var(--space__0-75x) var(--space__0-25x);
}
.timeline-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95px;
  z-index: 2;
}
.status-circle {
  width: 90px;
  height: 64px;
  border-radius: 50%;
  background: #9e9e9e;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;  
  padding-top: 40px;
  padding-bottom: 40px
}
.status-circle.active {
  background: #0a4f21;
}
.label {
  margin-top: 8px;
  font-size: 14px;
  color: #555;
  font-weight: 500;
  text-align: center;
  white-space: normal;
}
.label.active {
  color: #000;
}
.connector {
  height: 4px;
  flex-grow: 1;
  min-width: 10px;
  background: #9e9e9e;
  margin: 0;                   
  position: relative;
  margin-top: 40px;
  top: 0; 
}
.connector.active {
  background: #0a4f21;
}
</style>